import React, { useCallback, useEffect } from 'react'
import { Modal } from './Modal'

import '../assets/css/style.css'

interface DisclaimerModalProps {
  isShow: boolean
  setShow: (isShow: boolean) => void
}

export const DisclaimerModal: React.FC<DisclaimerModalProps> = React.memo((props) => {
  const { isShow, setShow } = props
  useEffect(() => {
    if (isShow) {
      document.body.setAttribute('style', 'overflow: hidden;')
    } else {
      document.body.removeAttribute('style')
    }

    return () => document.body.removeAttribute('style')
  }, [isShow])

  const handleHide = useCallback(() => {
    setShow(false)
  }, [setShow])

  return (
    <React.Fragment>
      {isShow && (
        <Modal className={'c-modal'}>
          <div className="c-modal__content">
            <div className="c-modal__head">
              {/* eslint-disable-next-line jsx-a11y/heading-has-content */}
              <h2 className="c-modal__head__title"></h2>
              <span className="c-modal__head__close" onClick={handleHide}></span>
            </div>
            <div className="c-modal__body">
              <h3 className="c-heading-1">サービス内容</h3>
              <p>
                本サービスの提供は、野村アセットマネジメント株式会社（以下「当社」といいます。）が行っております。
                <br className="spOnly" />
              </p>
              <p>
                本サービスは、手数料、税金等は考慮しておらず、実際の計算とは異なります。入力された取引と全く同様の取引を現実に行った場合でも、
                本サービスで表示される結果と現実の結果が一致しない場合があります。
                <br className="spOnly" />
                <br className="spOnly" />
              </p>
              <p>
                本サービスは、投資勧誘を目的とするものではなく、シミュレーション等に基づく参考表示による、
                情報提供を目的とするものであり、金融商品取引法に基づく開示書類ではありません。
              </p>
              <h4>著作権</h4>
              <p>
                本サービスの著作権等の知的財産権その他一切の権利は、当社又は当社にライセンス提供を行う情報提供者に帰属し、当社の許可なく本サービスに掲載している情報等を複製、公衆送信等することはできないものとします。
                <br className="spOnly" />
              </p>
              <p>
                当社は、本サービス（本サービスに掲載している情報を含みます）について、利用者への予告なしに変更又は中止できるものとします。
                <br className="spOnly" />
              </p>
              <p>
                本サービスをご利用の際は、以上のことをご理解、ご承諾されたものとさせていただきます。
              </p>
              <h4>営利商用目的利用の禁止</h4>
              <p>営利目的又は商用利用目的で、本サービスを利用することはできないものとします。</p>

              <h3 className="c-heading-1">免責事項</h3>
              <h4>(1)無保証</h4>
              <p>
                本サービスのいかなる内容も、将来の運用成果を示唆、予測あるいは保証するものではありません。
                本サービスのコンテンツは相当の注意をもって作成されましたが、当社が、その内容の正確性、完全性、信頼性、使用可能性、有用性及び適時性を保証するものではありません。
              </p>
              <h4 className="u-mt1em">(2)自己責任</h4>
              <p>
                お客様は本サービスの利用に当たっては、シミュレーション等について、自己の責任で判断するものとします。
                <br className="spOnly" />
              </p>
              <p>
                当社は、本サービスの仕様もしくは本サービスの内容の変更、または本サービスの提供の中断、停止もしくは終了によって生じたいかなる損害について、一切の責任を負わないものとします。
                <br className="spOnly" />
              </p>
              <p>
                また当社は、本サービスの利用により取得される情報を用いてお客様が行った有価証券の売買その他の取引の結果についても、一切の責任を負わないものとします。
                <br className="spOnly" />
              </p>
              <p>
                投資判断、資産運用の最終決定に際しては、必ず投資信託説明書（交付目論見書）を確認する等、お客様ご自身の責任においてご判断ください。
              </p>
              <h4 className="u-mt1em">(3)お客様の当社に対する補償</h4>
              <p>
                お客様の本サービスの利用、お客様による第三者の権利侵害に起因又は関連して紛争が生じた場合は、
                すべてお客様の費用と責任で解決するものとします。
              </p>
            </div>
          </div>
          <div className="c-modal__overlay" onClick={handleHide}></div>
        </Modal>
      )}
    </React.Fragment>
  )
})
